<template>
    <div>
        <loading-gdb :propObject="$store.state.rm.info_aluno_loading" />
        <v-row>
            <v-col sm="8" md="6">
                <v-text-field v-model="matricula" v-mask="'###-######'" label="Matrícula"
                    hide-details @keyup.enter="searchMatricula">
                    <template v-slot:append>
                        <v-btn @click.stop="searchMatricula" color="primary">
                            <v-icon>mdi-magnify</v-icon> Pesquisar</v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-divider class="my-4"></v-divider>
        <h3 class="mb-2">Status do cadastro no RM</h3>
        <div v-if="results.length">
            <v-row v-for="alu, index in results" :key="index" dense>
                <v-col sm="8" md="9">
                    <v-btn @click.stop="openAlu(alu)" color="primary">
                        <v-icon small>mdi-eye-outline</v-icon> Visualizar
                    </v-btn>
                    <span class="mt-1 mx-2">{{alu.RA}} - {{alu.NOME}}</span>
                </v-col>
            </v-row>
        </div>
        <div v-else class="text-grey">
            <small><i>Aguardando pesquisa...</i></small>
        </div>
        <!-- CADASTRO IDSECURE -->
        <div v-if="cadastro_idsecure">
            <v-divider class="my-4"></v-divider>
            <h3 class="mb-2">Status do cadastro no sistema de Catracas</h3>
            <v-row >
                <v-col sm="12" md="4" lg="3">
                    <div v-if="cadastro_idsecure.foto">
                        <v-img :src="'data:image/png;base64,'+cadastro_idsecure.foto" width="200" style="border-radius:10px"></v-img>
                    </div>
                    <div :class="cadastro_idsecure.photoIdFaceState == 1 ? 'text-success' : 'text-error'">
                        <div class="mt-2">
                            <i class="text-grey">Status: </i>
                        </div>
                        <b>{{resultTest[cadastro_idsecure.photoIdFaceState]}}</b>
                    </div>
                    <div v-if="cadastro_idsecure.photoIdFaceState !== 1" class="info--text">
                        <small><i>Recomendado a captura de uma nova foto. (Clique em "Visualizar" no Status de cadastro do RM)</i></small>
                    </div>
                </v-col>
                <v-col sm="12" md="8" lg="9">
                    <div>
                        <span :title="cadastro_idsecure.id" v-text="cadastro_idsecure.idDevice"></span> - <span v-text="cadastro_idsecure.name" :title="cadastro_idsecure.registration"></span>
                    </div>
                    <div v-if="cadastro_idsecure.photoIdFaceState !== 1" class="info--text">
                        <div class="text-grey">
                            <i>Após a captura da foto, pode demorar até 2 minutos para a conclusão de processamento da mesma.</i>
                        </div>
                        <div class="text-grey">
                            <i>Se, mesmo após 2 minutos nenhum status de foto for exibido entre em contato com o TI.</i>
                        </div>
                        <div class="text-grey">
                            <i>Clique no botão abaixo para recarregar o cadastro para acompanhar a atualização de status.</i>
                        </div>
                        <div>
                            <v-btn @click.stop="searchMatricula" color="info">
                                <v-icon x-small>mdi-refresh</v-icon> Recarregar</v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <modal-gdb ref="modal_foto_aluno" code="modal_foto_aluno" toolbar-title="Atualização de foto do aluno" dialogWidth="70%">
            <template v-slot:activate-slot>
                <span></span>
            </template>
            <template v-slot:body>
                <div>
                    <b>Matrícula:</b> {{selectedAlu.RA}}
                </div>
                <div>
                    <b :title="selectedAlu.CODPESSOA">Nome:</b> {{selectedAlu.NOME}}
                </div>
                <v-divider class="my-3"></v-divider>
                <v-row>
                    <v-col cols="12" sm="12">
                        <CapturaFoto @image-changed="onSelectedImage"
                                        :showOutPreview="false"/>
                    </v-col>
                    <v-col cols="12" sm="6" align="right">
                        <div v-if="originalTempFoto">
                            <span class="text-error"><b>Imagem anterior</b></span>
                            <v-img title="Original" :src="'data:image/png;base64,'+originalTempFoto" width="200" style="border:solid #f00 2px"></v-img>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div>
                            <span v-if="originalTempFoto" class="text-success"><b>Nova Imagem</b></span>
                            <span v-else>
                                <b class="text-success" v-if="selectedAlu.IMAGEM">Imagem atual</b>
                                <b class="text-error" v-else>Nenhuma Imagem cadastrada no RM</b>
                            </span>
                            <v-img title="Nova" v-if="selectedAlu.IMAGEM" :src="'data:image/png;base64,'+selectedAlu.IMAGEM" width="200" aspect-ratio="1" style="border:solid #0f0 2px"></v-img>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>
                <v-row>
                    <v-spacer></v-spacer>
                    <v-btn class="mx-1" @click.stop="closeModal" small color="error">Cancelar</v-btn>
                    <v-btn class="mx-1" @click.stop="updateImagem(selectedAlu)" small color="success"
                        v-if="(originalTempFoto != selectedAlu.IMAGEM) && selectedAlu.IMAGEM">Atualizar</v-btn>
                    <v-spacer></v-spacer>
                </v-row>
            </template>
        </modal-gdb>
        <loading-gdb :dialog="StateInfoAlunoLoading || StateIDSecurePessoasLoading"/>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import CapturaFoto from '../layouts/partials/CapturaFoto.vue'
export default {
    components:{
        CapturaFoto
    },
    data:()=>({
        originalTempFoto:null,
        matricula:null,
        results:[],
        selectedAlu:{},
        cadastro_idsecure:null,
        resultTest:{
            0  : 'Status desconhecido',
            1  : 'Processada com sucesso',
            2  : 'Rosto muito longe',
            3  : 'Rosto muito perto',
            4  : 'Face não centralizada',
            5  : 'Postura do rosto não centralizada',
            6  : 'Baixa Nitidez',
            7  : 'Rosto não detectado',
            8  : 'Face já existente',
            9  : 'Tamanho de imagem desconhecido',
            10 : 'Imagem Pequena',
            11 : 'Imagem muito grande',
            12 : 'Usuário não existe',
            13 : 'Muitas faces já estão cadastradas no dispositivo',
            14 : 'Rosto muito perto das bordas da imagem',
        },
    }),
    mounted(){
    },
    methods:{
        ...mapActions(['GetAlunoImage', 'SetAlunoImage', 'GetIDSecurePessoa']),
        async searchMatricula(){
            if(!this.matricula || (this.matricula||'').length < 10){
                alert('Verifique se a matrícula digitada está correta')
                return
            }
            let response = await this.GetAlunoImage(this.matricula)
            if(response.status == 200){
                this.results = response.data
            }else{
                this.results = []
            }
            let cadastro_idsecure = await this.GetIDSecurePessoa(this.matricula)
            if (cadastro_idsecure.status == 200){
                this.cadastro_idsecure = Object.assign({},cadastro_idsecure.data)
            }else{
                this.cadastro_idsecure = null
            }
        },
        openAlu(alu){
            this.selectedAlu = Object.assign({}, alu)
            this.$refs.modal_foto_aluno.dialog = true
            this.clearTemp()
        },
        closeModal(){
            this.$refs.modal_foto_aluno.dialog = false
            this.clearSelected()
        },
        // saveTemp(){
        //     // salvar base64 da imagem original
        //     const originalTempFoto = this.selectedAlu.IMAGEM
        //     this.originalTempFoto = Object.assign({}, originalTempFoto)
        // },
        // recoveryTemp(){
        //     // em caso de desistencia, não perder o base64 da imagem original
        //     const recoveryOriginal = this.originalTempFoto
        //     this.clearTemp()
        //     return recoveryOriginal
        // },
        clearTemp(){
            this.originalTempFoto = null
        },
        clearSelected(){
            this.selectedAlu = Object.assign({}, {})
        },
        onSelectedImage(value){
            if (value){
                const originalTempFoto = this.selectedAlu.IMAGEM
                this.originalTempFoto = originalTempFoto
                this.selectedAlu.IMAGEM = value
            }else{
                const recoveryOriginal = this.originalTempFoto
                this.selectedAlu.IMAGEM = recoveryOriginal
                this.clearTemp()
            }
        },
        async updateImagem(value){
            const {CODPESSOA, IMAGEM} = value
            const data = {
                codpessoa: CODPESSOA,
                payload :{
                    image: IMAGEM
                }
            }
            let response = await this.SetAlunoImage(data)
            if(response.status==200){
                this.closeModal()
                this.searchMatricula()
            }else{
                console.error(response)
            }
        }
    },
    computed:{
        ...mapGetters(['StateInfoAlunoLoading','StateIDSecurePessoasLoading'])
    }
}
</script>
